import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './BrowserNotSupported.style';
var BrowserNotSupported = function (_a) {
    var classes = _a.classes;
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", { className: classes.upperContainer }),
        React.createElement("div", { className: classes.infoContainer },
            React.createElement("div", { className: classes.title }, "Browser not supported"),
            React.createElement("div", { className: classes.subtitle }, "We recommend using TrainingTube with one of the following browsers:"),
            React.createElement("div", { style: { marginLeft: 40, display: 'flex' } },
                React.createElement("span", { style: { margin: 'auto', display: 'flex', cursor: 'pointer' }, onClick: function () {
                        return (window.location.href =
                            'https://www.google.com/chrome/?brand=BNSD&gclid=Cj0KCQiAifz-BRDjARIsAEElyGKwN5j6DOAsVlck-LyEDM3G6cG6Bl9gMWxoxmwUC0lKpeEFW9d14XwaAgB1EALw_wcB&gclsrc=aw.ds');
                    } },
                    React.createElement("img", { src: "./assets/images/chrome.png", style: { width: 55, height: 55 } }),
                    React.createElement("span", { className: classes.text }, "Google Chrome")),
                React.createElement("span", { style: { margin: 'auto', display: 'flex', cursor: 'pointer' }, onClick: function () { return (window.location.href = 'https://www.microsoft.com/en-us/edge'); } },
                    React.createElement("img", { src: "./assets/images/edge.png", style: { width: 55, height: 55 } }),
                    React.createElement("span", { className: classes.text }, "Microsoft Edge")),
                React.createElement("span", { style: { margin: 'auto', display: 'flex', cursor: 'pointer' }, onClick: function () { return (window.location.href = 'https://www.mozilla.org/en-US/firefox/new/'); } },
                    React.createElement("img", { src: "./assets/images/firefox.png", style: { width: 55, height: 55 } }),
                    React.createElement("span", { className: classes.text }, "Firefox"))))));
};
export default withStyles(styles)(BrowserNotSupported);



//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/ResourseNotFound/BrowserNotSupported.tsx
// module id = 2022
// module chunks = 81